import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { H2 as H2$1, H1 as H1$1, H3 as H3$1, H4 as H4$1, H5 as H5$1, H6 as H6$1 } from './heading.css.js';

function H1({ className, hero, italic, ...rest }) {
  const classes = clsx(H1$1({ hero, italic }), className);
  return /* @__PURE__ */ jsx("h1", { className: classes, ...rest });
}
function H2({ className, italic, ...rest }) {
  const classes = clsx(H2$1({ italic }), className);
  return /* @__PURE__ */ jsx("h2", { className: classes, ...rest });
}
function H3({ className, italic, ...rest }) {
  const classes = clsx(H3$1({ italic }), className);
  return /* @__PURE__ */ jsx("h3", { className: classes, ...rest });
}
function H4({ className, italic, ...rest }) {
  const classes = clsx(H4$1({ italic }), className);
  return /* @__PURE__ */ jsx("h4", { className: classes, ...rest });
}
function H5({ className, italic, ...rest }) {
  const classes = clsx(H5$1({ italic }), className);
  return /* @__PURE__ */ jsx("h5", { className: classes, ...rest });
}
function H6({ className, italic, ...rest }) {
  const classes = clsx(H6$1({ italic }), className);
  return /* @__PURE__ */ jsx("h6", { className: classes, ...rest });
}

export { H1, H2, H3, H4, H5, H6 };
